import { PREMIUM_EDITION } from '@jira/platform__application-editions/src/edition.tsx';
import type { HamPermissionChecksResult } from './ItamPermissionsContext.tsx';

const SERVICE_DESK_USER_PERMISSION_ID = 'jsd-user';

/**
 * Whether the ITAM navigation entry should be shown, derived the same way as
 * `useItamTenantContext`: the user must have JSM access, the required license,
 * HAM view permission and the Jira Service Desk user permission.
 */
export const computeShouldShowItam = (
	hasServiceDeskAccess: boolean,
	serviceDeskEdition: string | null | undefined,
	checks: HamPermissionChecksResult | null,
): boolean =>
	Boolean(
		checks &&
		hasServiceDeskAccess &&
		serviceDeskEdition === PREMIUM_EDITION &&
		checks.permissions[SERVICE_DESK_USER_PERMISSION_ID],
	);
